import React from 'react';
export function ProductLinesSolutionsSection() {
  const categories = [{
    id: 'used-machines',
    label: 'Used Machines'
  }, {
    id: 'edm',
    label: 'EDM'
  }, {
    id: 'cnc-milling',
    label: 'CNC Milling'
  }, {
    id: 'cnc-turning',
    label: 'CNC Turning'
  }, {
    id: 'laser',
    label: 'Laser Cutting'
  }, {
    id: 'automation',
    label: 'Automation'
  }, {
    id: 'product-lines',
    label: 'Product Lines Available at Peak'
  }];
  const handleCategoryClick = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-16 md:pt-24 pb-6 bg-gray-50" data-id="element-2806">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2807">
        <div className="text-center" data-id="element-2808">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-2809">
            Product Lines & Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6" data-id="element-2810">
            Explore Peak's core equipment categories and product lines.
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-2811">
            {categories.map(category => <a key={category.id} href={`#${category.id}`} onClick={e => handleCategoryClick(e, category.id)} className="px-4 py-2 bg-white border-2 border-gray-200 rounded-full text-sm font-medium text-navy hover:border-orange hover:text-orange transition-all" data-id="element-2812">
                {category.label}
              </a>)}
          </div>
        </div>
      </div>
    </section>;
}